const translations = {
  dashboard: 'Dashboard',
  groupMessage: 'Create or select group in the menu on the left.',
  importUsersMessage: 'Import users via email or Google Classroom, or create anonymous student accounts using the buttons below.',
  importUsers: 'IMPORT USERS',
  createUsers: 'CREATE ANONYMOUS STUDENT ACCOUNTS',
};

export default translations;
